import { H2, H4 } from '../../../common/typography'
import { colors } from 'shared/assets/styles'
import type { WinningType } from '../../types'
import { useIntl } from 'react-intl'
import React from 'react'
import type { Gain } from 'shared/store/tu-preferes-king/types'

const BigText = ({ children }) => (
    <H2 color={colors.bbqBrown} center>
        {children}
    </H2>
)

const SmallText = ({ children }) => (
    <H4 color={colors.bbqBrown} center>
        {children}
    </H4>
)

export const WinningDescription = ({
    winning,
    type,
    small
}: {
    winning?: Gain,
    type: WinningType,
    small?: boolean
}) => {
    const intl = useIntl()
    const HElement = small ? SmallText : BigText
    const hasInfo =
        winning &&
        winning.name &&
        (winning.name === 'Bouée Whopper®' ||
            winning.name === 'Frisbee Burger King' ||
            winning.name === 'Casquette enfant Burger King' ||
            winning.name === 'Bracelet enfant Burger King')
    if (winning) {
        return (
            <HElement>
                {winning.name}
                {hasInfo &&
                    intl.formatMessage({
                        id: 'tupreferesking.duel.carefull.title'
                    })}
            </HElement>
        )
    }

    return (
        <HElement>
            <strong>
                {intl.formatMessage({
                    id: `tupreferesking.duel.gift`
                })}
            </strong>
            <br />
            <strong>
                {intl.formatMessage({
                    id: `tupreferesking.duel.${type}`
                })}
            </strong>
        </HElement>
    )
}
